<template>
    <q-avatar 
        v-if="user || contact"
        :class="{
            ['relative-position ' + textColor]: (!user.avatar_path || avatarBroken),
            'bordered': bordered,
        }"
        :style="`background-color: ${backgroundColor};`"
        :key="user?.avatar_path ?? contact?.id"
    >
        <template v-if="(!user.avatar_path ?? false) || avatarBroken">
            {{ name.first_name.charAt(0) }}{{ name.last_name.charAt(0) }}
        </template>
        <img v-else 
            :src="user.avatar_path" 
            :alt="user.name"
            @error="avatarBroken = true"
        >
        <slot />
    </q-avatar>
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        user: {
            type: [Boolean, Object],
            default: false,
        },
        contact: {
            type: [Boolean, Object],
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            avatarBroken: false,
        };
    },
    computed: {
        name() {
            let name = this.user?.name ?? this.contact?.org_name ?? (this.contact?.first_name + ' ' + this.contact?.last_name) ?? 'Unknown';
            let nonce = this.user?.employee_id ?? this.user?.id ?? this.contact?.id ?? 0;

            nonce += Math.floor(new Date(this.user?.created_at ?? this.contact?.created_at ?? 0).getTime() / 1000);

            if (typeof name === 'string') {
                const split = name.split(' ');

                if (split.length === 1) {
                    name = {
                        id: nonce,
                        first_name: split[0].trim(),
                        last_name: '',
                    };
                } else {
                    name = {
                        id: nonce,
                        first_name: split[0].trim(),
                        last_name: split[split.length - 1]?.trim() ?? '',
                    };
                }
            }

            return name;
        },
        backgroundColor() {
            if (this.user?.avatar_path && !this.avatarBroken) {
                return undefined;
            }
            
            return this.stringToHexColor(this.name.id + this.name.first_name + this.name.last_name);
        },
        textColor() {
            const bg = this.backgroundColor ?? false;

            if (!bg) return 'text-white';

            return this.isDarkRadial(bg, 'text-grey-1', 'text-grey-10');
        }
    }
}
</script>

<style lang="scss" scoped>
.body--dark {
    .bordered {
        border: 1px solid white;
    }
}

.bordered {
    border: 1px solid black;
}
</style>